import { Button, Card, Input, message, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { MdAdd } from 'react-icons/md';
import { Link, useHistory } from 'react-router-dom';
import Layout from '../../components/Layout';
import api from '../../services/api';

import { Container } from './styles';

interface Category {
  _id: string;
  name: string;
  description: string;
}

const Categories: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);

  const history = useHistory();

  useEffect(() => {
    async function loadData(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get('categories');

        setCategories(response.data);
      } catch (err) {
        message.error('Erro ao carregar dados');
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, []);

  if (loading) {
    return (
      <Layout title="Categorias">
        <Spin style={{ marginTop: '50%' }} size="large" />
      </Layout>
    );
  }

  return (
    <Layout title="Categorias">
      <Container>
        <h2>Gerenciamento de Categorias</h2>

        <div id="controls">
          <Button
            icon={<MdAdd />}
            size="large"
            onClick={() => history.push('/categories/add')}
          >
            Adicionar
          </Button>

          <Input.Search
            placeholder="Pesquisar"
            size="large"
            style={{ maxWidth: 290 }}
          />
        </div>

        <div className="category-grid">
          {categories.map(category => (
            <Link key={category._id} to={`/categories/${category._id}`}>
              <Card
                className="card"
                title={category.name}
                style={{ width: 300 }}
              >
                <p>{category.description}</p>
              </Card>
            </Link>
          ))}
        </div>
      </Container>
    </Layout>
  );
};

export default Categories;
